import {Dayjs} from 'dayjs';
import dayjs from 'dayjs';

export class PriceAdjustment {

    id: number
    product_id: number;
    original_price: number;
    change_pct: number;
    previous_price: number;
    last_change_pct: number;
    price: number;
    costprice_2: number;
    margin: number;
    minium_margin: number;
    minimum_price: number;
    competitor_data: any;
    last_changed: Dayjs;
    note: string;
    competitor_count: number;
    competitor_diff: number;
    minimum_competitor_price: number;
    deviation_pct: number;
    shipping_cost: number;
    active: boolean;
    is_paused: boolean;

    is_campaign: boolean;
    campaign_name: string;
    is_notification_only: boolean;
    modified: Dayjs;
    created: Dayjs;

    static _JSONProps: string[] = [
        'id',
        'product_id',
        'original_price',
        'change_pct',
        'previous_price',
        'last_change_pct',
        'price',
        'costprice_2',
        'margin',
        'minium_margin',
        'minimum_price',
        'competitor_data',
        'last_changed',
        'note',
        'competitor_count',
        'competitor_diff',
        'minimum_competitor_price',
        'deviation_pct',
        'shipping_cost',
        'active',
        'is_paused',
        'is_campaign',
        'campaign_name',
        'is_notification_only',
    ];

    constructor(initializer?: PriceAdjustmentInterface) {
        if (initializer === undefined) {
            return;
        }
    }

    static fromJSON(json: PriceAdjustmentInterface | string): PriceAdjustment {
        if (json === null) {
            return new PriceAdjustment();
        }

        if (typeof json === 'string') {
            return JSON.parse(json, PriceAdjustment.reviver);
        } else {
            const task = Object.create(PriceAdjustment.prototype);

            let extra = {
                modified: dayjs(json.modified),
                created: dayjs(json.created),
                last_changed: dayjs(json.last_changed),
            };

            Object.keys(json).forEach((key, index) => {
                if (PriceAdjustment._JSONProps.indexOf(key) !== -1) {
                    task[key] = json[key];
                }
            });

            return Object.assign(task, extra);
        }
    }

    static reviver(key: string, value: any): any {
        return key === "" ? PriceAdjustment.fromJSON(value) : value;
    }
}

// A representation of Token data that can be converted to
// and from JSON without being altered.
export interface PriceAdjustmentInterface extends PriceAdjustment {
}
